<template>
  <div class="filter-card p-3 mb-3 mb-md-0 flex-grow-1">
    <b-form-group
        :label="$t('select_recipient_group')"
        label-for="recipient-group"
        label-class="font-weight-bold"
    >
      <multiselect
          id="recipient-group"
          :value="multiselectValue"
          :options="roleOptions"
          :multiple="!singleSelect"
          :close-on-select="singleSelect"
          :clear-on-select="false"
          :preserve-search="true"
          :placeholder="$t('select_group')"
          label="text"
          track-by="value"
          @input="onRolesInput"
          @open="isRecipientGroupOpen = true"
          @close="isRecipientGroupOpen = false"
      />
    </b-form-group>

    <b-form-group
        v-if="userCount > 0"
        :label="$t('search_users')"
        label-for="user-search"
        label-class="font-weight-bold"
    >
      <b-input-group>
        <b-form-input
            id="user-search"
            :value="searchQuery"
            :placeholder="$t('search_by_name_or_email')"
            debounce="300"
            @input="$emit('update:searchQuery', $event)"
        ></b-form-input>
        <b-input-group-append>
          <b-button
              variant="outline-secondary"
              @click="$emit('update:searchQuery', '')"
              v-if="searchQuery"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group
      v-if="showOnboardingFilter && userCount > 0 && hasSelectedRoles"
      class="mb-2 onboarding-filter-group"
    >
      <b-form-checkbox
        :checked="onboardingCompletedOnly"
        @change="$emit('update:onboardingCompletedOnly', $event)"
      >
        {{ $t('onboarding_completed_users_only') }}
      </b-form-checkbox>
    </b-form-group>

    <div v-if="userCount > 0" class="mt-4">
      <h6 class="font-weight-bold mb-2">{{ $t("quick_actions") }}</h6>
      <div class="d-flex flex-column gap-2">
        <b-button
            block
            variant="outline-primary"
            @click="$emit('select-all')"
            class="text-left d-flex align-items-center"
        >
          <feather-icon icon="CheckSquareIcon" size="16" class="mr-1"/>
          {{ $t("select_all") }}
        </b-button>
        <b-button
            block
            variant="outline-secondary"
            @click="$emit('deselect-all')"
            class="text-left d-flex align-items-center mt-2"
        >
          <feather-icon icon="SquareIcon" size="16" class="mr-1"/>
          {{ $t("deselect_all") }}
        </b-button>
      </div>

      <div class="mt-4 p-2 bg-light rounded text-center">
        <div class="h3 font-weight-bold mb-0 text-primary">{{ selectedCount }}</div>
        <small class="text-muted text-uppercase font-weight-bold">{{ $t("recipients_selected") }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import Multiselect from "vue-multiselect";

export default {
  name: "EmailRecipientFilters",

  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BButton,
    Multiselect,
  },

  props: {
    selectedRoles: {
      type: Array,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    userCount: {
      type: Number,
      default: 0,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    showOnboardingFilter: {
      type: Boolean,
      default: true,
    },
    onboardingCompletedOnly: {
      type: Boolean,
      default: true,
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRecipientGroupOpen: false,
    };
  },
  computed: {
    hasSelectedRoles() {
      return Array.isArray(this.selectedRoles) && this.selectedRoles.length > 0;
    },
    multiselectValue() {
      if (this.singleSelect) {
        return (this.selectedRoles && this.selectedRoles[0]) || null;
      }
      return this.selectedRoles;
    },
  },
  methods: {
    onRolesInput(value) {
      if (!this.singleSelect) {
        this.$emit('update:selectedRoles', value || []);
        return;
      }
      const selected = Array.isArray(value) ? (value[0] || null) : value;
      this.$emit('update:selectedRoles', selected ? [selected] : []);
    },
  },
};
</script>

<style scoped>
.filter-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border: 1px solid #e9ecef;
  height: 100%;
}
.onboarding-filter-group {
  position: relative;
  z-index: 0;
}
.multiselect__content-wrapper{
  z-index: 5;
}
.gap-2 {
  gap: 0.5rem;
}
</style>
